module.exports = __webpack_public_path__ + "img/paas-dash.38580a07.svg";